import { mapActions } from 'vuex'
import { REFRESH_DATA_EVENT } from 'enums/refresh-data'

const SAVED_ENTITY = {
  ARTICLE: 'Article',
  COMPANY: 'Company',
  TAG: 'Tag',
  CATEGORY: 'Category',
  AUTHOR: 'Author'
}

export default {
  computed: {
    $_refreshDataHandler_savedEntity() {
      return SAVED_ENTITY
    }
  },
  methods: {
    ...mapActions({
      requestAuthor: 'author/requestAuthor',
      requestTagBySlug: 'tag/requestTagBySlug'
    }),
    $_refreshDataHandler_updateIsSavedValue(
      { id, value },
      articles = this.articles
    ) {
      return articles.map(article => ({
        ...article,
        ...(article.id === id ? { isSaved: value } : {})
      }))
    },
    $_refreshDataHandler_updateIsFollowedTagValue({
      id,
      value,
      articles = this.articles,
      tagListFieldName = 'tags',
      tagIdFieldName = 'id',
      isFollowedFieldName = 'isFollowed'
    }) {
      return articles.map(article => {
        const isMainTagUpdated =
          article.mainTag && article.mainTag[tagIdFieldName] === id

        return {
          ...article,
          ...(isMainTagUpdated
            ? {
                mainTag: {
                  ...article.mainTag,
                  isFollowed: value
                }
              }
            : {}),
          [tagListFieldName]: article[tagListFieldName].map(tag => ({
            ...tag,
            [isFollowedFieldName]:
              tag[tagIdFieldName] === id ? value : tag[isFollowedFieldName]
          }))
        }
      })
    },
    $_refreshDataHandler_resetActionIconValues(articles = this.articles) {
      return articles.map(article => ({
        ...article,
        IsSaved: false,
        Tag: { ...article.Tag, IsFollowed: false }
      }))
    },
    $_refreshDataHandler_updateArticleSavedEntities(
      { articleIds, tagIds },
      articles = this.articles
    ) {
      return articles.map(article => ({
        ...article,
        ...(articleIds && articleIds.includes(article.Id)
          ? { IsSaved: true }
          : {}),
        ...(tagIds && tagIds.includes(article.Tag.Id)
          ? { Tag: { ...article.Tag, IsFollowed: true } }
          : {})
      }))
    },
    async $_refreshDataHandler_getIsFollowedAuthorValue(payload) {
      try {
        const { IsFollowed } = await this.requestAuthor(payload)
        return IsFollowed
      } catch (err) {
        this.$errorHandler(err, this)
        return false
      }
    },
    async $_refreshDataHandler_getSingleArticleEntities(payload) {
      try {
        const {
          isSaved,
          author: { isFollowed },
          tags
        } = await this.requestArticleContentBySlug(payload)

        return {
          isSaved,
          isFollowed,
          tags
        }
      } catch (err) {
        this.$errorHandler(err, this)
        return {}
      }
    },
    async $_refreshDataHandler_getIsFollowedTagValue(payload) {
      try {
        const { IsFollowed } = await this.requestTagBySlug(payload)
        return IsFollowed
      } catch (err) {
        this.$errorHandler(err, this)
        return false
      }
    },
    $_refreshDataHandler_updateIsFollowedAuthorValue({
      id,
      value,
      articles = this.articles,
      authorListFieldName = 'authors',
      authorIdFieldName = 'id',
      isFollowedFieldName = 'isFollowed'
    }) {
      return articles.map(article => {
        return {
          ...article,
          [authorListFieldName]: article[authorListFieldName].map(author => ({
            ...author,
            [isFollowedFieldName]:
              author[authorIdFieldName] === id
                ? value
                : author[isFollowedFieldName]
          }))
        }
      })
    },
    $_refreshDataHandler_updateIsFollowedCategoryValue({
      id,
      value,
      articles = this.articles
    }) {
      return articles.map(article => {
        return {
          ...article,
          notificationCategories: article.notificationCategories.map(
            category => ({
              ...category,
              isFollowed: category.id === id ? value : category.isFollowed
            })
          )
        }
      })
    },
    $_refreshDataHandler_emitRefresh(type, payload) {
      this.$bus.$emit(REFRESH_DATA_EVENT.REFRESH_DATA, { type, payload })
    }
  }
}
